import {
    GET_FUEL_TYPE,
    SET_FUEL_TYPE
} from "./FuelTypeTypes"

const getFuelType = (subTypeId: any) => ({
    type: GET_FUEL_TYPE,
    subTypeId
});

const setFuelType = (fuelTypeList: any) => ({
    type: SET_FUEL_TYPE,
    fuelTypeList
});

export {
    getFuelType,
    setFuelType
}
